import React from "react";
import "./audioPlayer.css";

function AudioPlayer(_ref) {
  var play = _ref.play,
      reverse = _ref.reverse;
  return /*#__PURE__*/React.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wifi-symbol " + (reverse ? "reverse" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "wifi-circle " + (reverse ? "reverseColor" : "") + " first"
  }), /*#__PURE__*/React.createElement("div", {
    className: "wifi-circle second " + (play ? "secondPlay" : "") + (reverse ? " reverseColor" : "")
  }), /*#__PURE__*/React.createElement("div", {
    className: "wifi-circle third " + (play ? " thirdPlay" : "") + " " + (reverse ? "reverseColor" : "")
  })));
}

export default AudioPlayer;